import TextValue from "./TextValue.vue";
export default {
  name: "HighlightTextValue",
  components: {
    TextValue
  },
  props: {
    value: {
      type: [String, null],
      required: true
    },
    // Search term to highlight within value.
    query: {
      type: [String, Array],
      default: ""
    },
    size: {
      type: [Number, String],
      default: 13
    },
    color: {
      type: String,
      default: "#4d4d4d"
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    main: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    highlightedValue() {
      const text = this.decodeHtml(this.value ?? "");
      const query = String(this.query ?? "").trim();
      if (!text || !query) return this.value;
      const lowerText = text.toLowerCase();
      const lowerQuery = query.toLowerCase();
      if (!lowerText.includes(lowerQuery)) return this.value;
      let result = "";
      let i = 0;
      while (i < text.length) {
        const idx = lowerText.indexOf(lowerQuery, i);
        if (idx === -1) {
          result += this.escapeHtml(text.slice(i));
          break;
        }
        result += this.escapeHtml(text.slice(i, idx));
        result += `<mark class="search-highlight">${this.escapeHtml(text.slice(idx, idx + query.length))}</mark>`;
        i = idx + query.length;
      }
      return result;
    }
  },
  methods: {
    decodeHtml(str) {
      const el = document.createElement("textarea");
      el.innerHTML = str;
      return el.value;
    },
    escapeHtml(str) {
      return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
  }
};